import { BASE_URL } from '../constants';
import { errorHandling, errorHandler } from '../utils/errorHandling';
import { getItem } from '../utils/localStore';

class connectDealerAccountApi {
    static doDealerConnectAccount(data) {
        const TOKEN = getItem('auth_token');
        let isError = false;
        let connectionaccountdata={
            broker_dealer_mpid: data.mpid,
            uid: data.uid,
            token: data.token,
            refresh_token: data.refresh_token,
            account_id: data.account_id,
            account_name: data.account_name,
            account_type: data.account_type,
            buying_power: data.buying_power 
        }
        try{
            const ajaxRequestHeaders = new Headers({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'Authorization': TOKEN,
            });
            let body = {
                method: 'POST',
                headers: ajaxRequestHeaders,
                body:JSON.stringify(connectionaccountdata)
            }
            return fetch(BASE_URL + '/broker_dealer_connections', body).then(response => {
                isError = errorHandling(response);
                return response.json();
            }).catch(error => {
                if (error && !isError) {
                    errorHandler(error);
                }
                return error;
            });
        }catch(err){
        }
    }
}

export default connectDealerAccountApi;